import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNavBarOptions } from './constants';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { useMemo } from 'react';

const BottomNavBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, isB2b } = useAuthContext();

  const navBarOptions = useMemo(() => getNavBarOptions(!!isB2b), [isB2b]);

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        px: 1,
        py: 1.5,
        zIndex: ({ zIndex }) => zIndex.appBar,
        borderRadius: (theme) =>
          `${theme.shape.borderRadius * 3.2}px ${
            theme.shape.borderRadius * 3.2
          }px 0 0`,
        boxShadow: '2px -4px 6px rgba(0, 0, 0, 0.1)',
      }}
      elevation={3}
    >
      <BottomNavigation showLabels value={pathname}>
        {navBarOptions.map((option) =>
          option.disabled ? null : (
            <BottomNavigationAction
              sx={{ color: 'iherit', transition: 'all 0.3s ease' }}
              value={option.href}
              key={option.label}
              label={
                <Typography
                  fontWeight={option.href === pathname ? 'bold' : 'medium'}
                >
                  {option.label.toLowerCase() === 'cuenta'
                    ? user
                      ? option.label
                      : 'Ingresar'
                    : option.label}
                </Typography>
              }
              icon={
                <Box
                  bgcolor={({ palette }) =>
                    pathname === option.href
                      ? palette.secondary.main
                      : 'inherit'
                  }
                  py={0.5}
                  px={2}
                  borderRadius={({ shape }) => shape.borderRadius}
                  color={({ palette }) => palette.grey[900]}
                >
                  {option.icon}
                </Box>
              }
              onClick={() => navigate(option.href)}
            />
          )
        )}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavBar;
